const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop-intelligence/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { loopIntelligenceSearchSchema } from '@/features/org-intelligence/components/filters/lensSearchSchema';
export const Route = createFileRoute('/(app)/org/$org/loop-intelligence/')({
  validateSearch: zodValidator(loopIntelligenceSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});